import React from "react";
import { Form } from "rsuite";

const ProfessionInfromation = () => {
  return (
    <div className="grid grid-cols-1 mt-3 md:grid-cols-2 lg:grid-cols-4 gap-4 mb-5">
      <Form.Group>
        <Form.ControlLabel>Profession</Form.ControlLabel>
        <Form.Control name="Profession" />
      </Form.Group>
      <Form.Group>
        <Form.ControlLabel>Company Name</Form.ControlLabel>
        <Form.Control name="CompanyName " />
      </Form.Group>
      <Form.Group>
        <Form.ControlLabel>Comapny Address</Form.ControlLabel>
        <Form.Control name="Organization Address" />
      </Form.Group>
      <Form.Group>
        <Form.ControlLabel>Income Mode</Form.ControlLabel>
        <Form.Control name="IncomeMode" />
      </Form.Group>
      <Form.Group>
        <Form.ControlLabel>Income Amount</Form.ControlLabel>
        <Form.Control name="IncomeAmount" />
      </Form.Group>
      <Form.Group>
        <Form.ControlLabel>Pan No.</Form.ControlLabel>
        <Form.Control name="PanNo" />
      </Form.Group>
      <Form.Group>
        <Form.ControlLabel>PF No.</Form.ControlLabel>
        <Form.Control name="PFNo" />
      </Form.Group>
      <Form.Group>
        <Form.ControlLabel>SSF No.</Form.ControlLabel>
        <Form.Control name="SSFNo" />
      </Form.Group>
    </div>
  );
};

export default ProfessionInfromation;
